import { createApi } from '@reduxjs/toolkit/query/react';

import { apiGocardlessPaymentBatches } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import {
  PaymentBatchDetail,
  PaymentBatchInvoicesResponse,
  PaymentBatchListResponse,
} from '~direct-debits/models';

interface BatchDetailQueryArgs {
  batch_id: string;
}

interface BatchClientInvoicesQueryArgs {
  batch_id: string;
  client_id: number;
}

export const paymentBatchesApi = createApi({
  reducerPath: 'directDebitsPaymentBatchesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiGocardlessPaymentBatches }),
  tagTypes: ['payment-batches', 'payment-batch-detail', 'payment-batch-invoices'],
  endpoints: (builder) => ({
    getPaymentBatches: builder.query<PaymentBatchListResponse, Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'payment-batches', id: 'LIST' }],
      transformResponse: (payload) => unwrap<PaymentBatchListResponse>(payload),
    }),
    getPaymentBatchDetail: builder.query<PaymentBatchDetail, BatchDetailQueryArgs>({
      query: ({ batch_id }) => ({ url: `/${batch_id}`, method: 'GET' }),
      providesTags: (_result, _error, { batch_id }) => [{ type: 'payment-batch-detail', id: batch_id }],
      transformResponse: (payload) => unwrap<PaymentBatchDetail>(payload),
    }),
    getPaymentBatchClientInvoices: builder.query<PaymentBatchInvoicesResponse, BatchClientInvoicesQueryArgs>({
      query: ({ batch_id, client_id }) => ({
        url: `/${batch_id}/clients/${client_id}/invoices`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { batch_id, client_id }) => [
        { type: 'payment-batch-invoices', id: `${batch_id}:${client_id}` },
      ],
      transformResponse: (payload) => unwrap<PaymentBatchInvoicesResponse>(payload),
    }),
  }),
});

export const {
  useGetPaymentBatchesQuery,
  useGetPaymentBatchDetailQuery,
  useGetPaymentBatchClientInvoicesQuery,
} = paymentBatchesApi;
